import { Routes, RouterModule } from '@angular/router';
import { Home } from './home';
import {Redirection} from '../../redirection';
import {NoContent} from './no-content';
import {SocialLoginComponent} from './social-login/social-login.component';
import {AcceptCookieComponent} from './accept-cookie/accept-cookie.component';
import {PluginListComponent} from './plugin-list/plugin-list.component';
import {RecoveryComponent} from './recovery/recovery.component';


const ROUTES: Routes = [
    {path: '', component: PluginListComponent},
    {path: 'home', component: Home},
    {path: 'redirection', component: Redirection},
    {path: 'accept_cookies', component: AcceptCookieComponent},
    {path: 'socialLogin', component: SocialLoginComponent},
    {path: 'recovery', component: RecoveryComponent},
    {path: '**', component: NoContent},
];

export { ROUTES };
